import { useTranslation } from 'react-i18next';
import Logo from '../assets/Logos/Logo-Excent-White.svg';
import LinkedIn from '../assets/Icons/linkedin.svg';
import Facebook from '../assets/Icons/facebook.svg';
import Instagram from '../assets/Icons/instagram.svg';
import X from '../assets/Icons/x.svg';
import Telegram from '../assets/Icons/telegram.svg';
import YouTube from '../assets/Icons/youtube.svg';
import config from '../translates/config';
import { dataCy, SELECTORS } from '../utils/dataCy';


function Footer() {
  const { i18n } = useTranslation('footer');

  return (
    <footer className="bg-primaryBg dark:bg-blueMenu px-6 sm:px-28 md:px-16 py-16 text-white text-xs">
      {/* Información de regulación y disclaimer */}
      <div>
        <ul className="list-none p-0 m-0">
          {config.footerDisclaimer.disclaimers[i18n.language]?.map((disclaimer, index) => (
            <li key={index}>{disclaimer}</li>
          )) || config.footerDisclaimer.disclaimers.en.map((disclaimer, index) => (
            <li key={index}>{disclaimer}</li>
          ))}
        </ul>
      </div>

      {/* Sección inferior con logo, copyright y redes sociales */}
      <div className="flex flex-col sm:flex-row gap-6 sm:gap-4 pt-8 items-center justify-between">
        {/* Logo y copyright */}
        <div className="flex flex-col sm:flex-row items-center gap-5 w-full sm:w-1/3 text-center sm:text-left">
          <img src={Logo} className="h-10" alt="Excent Capital Logo" />
          <p>© 2025. All rights reserved.</p>
          <p className="text-[#ffffff2d]">v1.8.4</p>
        </div>

        {/* Redes sociales */}
        <div className="flex gap-4 justify-center sm:justify-end w-full sm:w-2/3">
          <a href="https://www.linkedin.com/company/excentcapital" target="_blank" rel="noopener noreferrer" data-cy={dataCy(SELECTORS.LINK, 'footer-linkedin')}>
            <img src={LinkedIn} className="h-8" alt="LinkedIn" />
          </a>
          <a href="https://www.facebook.com/profile.php?id=61552842137817" target="_blank" rel="noopener noreferrer" data-cy={dataCy(SELECTORS.LINK, 'footer-facebook')}>
            <img src={Facebook} className="h-8" alt="Facebook" />
          </a>
          <a href="https://www.instagram.com/excentcapital" target="_blank" rel="noopener noreferrer" data-cy={dataCy(SELECTORS.LINK, 'footer-instagram')}>
            <img src={Instagram} className="h-8" alt="Instagram" />
          </a>
          <a href="https://x.com/ExcentCapital" target="_blank" rel="noopener noreferrer" data-cy={dataCy(SELECTORS.LINK, 'footer-x')}>
            <img src={X} className="h-8" alt="X (Twitter)" />
          </a>
          <a href="https://t.me/excentcapitalspn" target="_blank" rel="noopener noreferrer" data-cy={dataCy(SELECTORS.LINK, 'footer-telegram')}>
            <img src={Telegram} className="h-8" alt="Telegram" />
          </a>
          <a href="https://www.youtube.com/@ExcentCapital" target="_blank" rel="noopener noreferrer" data-cy={dataCy(SELECTORS.LINK, 'footer-youtube')}>
            <img src={YouTube} className="h-8" alt="YouTube" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
